import React from 'react';
import { Panel, PanelHeader, PanelBody } from './../../components/panel/panel.jsx';
import YSDVT01 from './../workinstructions/images/YSDVT01.png';
import Migo551scrap from './../workinstructions/images/Migo-551scrap.png';
import YSD_PACK from './../workinstructions/images/YSD_PACK.png';
import YSD_PACK002 from './../workinstructions/images/YSD_PACK002.png';
import YSD_PACK003 from './../workinstructions/images/YSD_PACK003.png';
import YSD_PACK03barcode01 from './../workinstructions/images/YSD_PACK03barcode01.png';
import YSD_PACK03barcode02 from './../workinstructions/images/YSD_PACK03barcode02.png';
import OTMnr from './../workinstructions/images/OTM-nr.png';
import OTMscratch01 from './../workinstructions/images/OTMscratch01.png';
import OTMscratch02 from './../workinstructions/images/OTMscratch02.png';

class RLC extends React.Component {
	async componentDidMount() {
    document.title = "RLC Work-Instructions";    
  }
	render() {
		return (
			<div>
		{/*				<ol className="breadcrumb float-xl-end">
					<li className="breadcrumb-item active">Cookie Acceptance Banner</li>
				</ol>
				<h1 className="page-header">Cookie Acceptance Banner <small>header small text goes here...</small></h1>   */}
				<Panel>
					<PanelHeader>RLC</PanelHeader>
					<PanelBody>
					<h2>Printer configuration</h2>
						<p>
							start SU3 =&gt; go to Tab-nav Defaults =&gt; go to inputfield Defaults and type in Output-device the printername of the paper-printer <br />
							=&gt; go to tab-nav Parameters =&gt; go to inputfield Zebra-printer the name of your zebraprinter
						</p>
						<h2>Xvak scrums register</h2>
						<p>
							For SWAP =&gt; Problem:  PO, DC Problem Statement: Scrap Approval<br />
							For IR =&gt; Problem , at DC-problem statement:  scrap case.<br />
							Shipment-type: FAULTY<br />
							Purchase order: POno<br />
							Vendor:  Look to the name of Vendor on the shipping-paper : for example Sanmina Hungary, Flextronics etc...<br />
							For Country: start  IQ09 =&gt; click history =&gt; click on Sales order =&gt; sold-to-part =&gt; partners =&gt; ship-to-party =&gt; look to country of sold partner<br />
							Vendor Reference:  RCT Dispatch #<br />
							Fill in Material-code, serial-nr =&gt; apply changes =&gt; print row-id with location with hubseno.
						</p>
						<h2>Xvak IR SCRAP</h2>
						<p>
							Start migo 943 : select Good Issue-other =&gt;  at Material Slip: IR SCRAP =&gt; fill in Material-code =&gt; at amount fill in 1 <br />
							at Where: FI28 bij Plant, at storage location fill in 1093, fill in serial-nr, fill in Faulty at batch, TEXT: IR SCRAP (scrap on site) <br />
							=&gt; click on check. When serial is blocked  =&gt; start IQ09 op remove batch or change/modify status if needed =&gt; go further with post, palletization<br />
							=&gt; click op confirm immediately, M32, location= scrap bin =&gt; save<br />
							Migo 551: <br />
							select Good Issue-other <br />At TEXT : IR SCRAP (scrap on site) row-id =&gt; click on check. When block: start IQ09 to remove batch or modify /change<br />
							status if needed =&gt; finish the process with post. =&gt; At account assigment: G/L acc: 443100, Profit segment =&gt; customer = 970223, <br />
							remove DUMMYPC =&gt; check =&gt; POST =&gt; F5 change storage type into M32 =&gt; F7 type 1 in for amount at scrapbin =&gt; generate =&gt; save <br />
							=&gt; start LT12 =&gt; enter =&gt; click on confirm immediately =&gt; save
						</p>
						<h2>Xvak Scrums Sending back to Customer</h2>
						<p>
							start YMB01 for receiving =&gt; fill PO-nr in =&gt; at Delivery Note fill in RCT-dispatch#  =&gt; select the right material-code =&gt; F6 =&gt; fill in the serial<br />
							=&gt; fill Faulty in batch =&gt; save<br /><br />
			
							Start VL10 =&gt; fill FI54 at Shippingpoint =&gt; make the field  Delivery creation-date empty =&gt; get SO from "Hisotry" of serial by using IQ09 =&gt; F8 =&gt; F5 =&gt; Shift F7 <br />
							=&gt; save =&gt; copy delivery nr. at empty =&gt; try with VL10N <br />
							If SO is unknown, use IQ09 and look in history and copy delivery-number at the yellow label. <br /><br />
							start VL01N =&gt; fill SO at Order, at Selection date set 1 year forward, so that it will be this day next year =&gt; enter =&gt; save =&gt; deliverynr is displaying left under the screen, click on it<br />
							=&gt; copy delivery-nr, by clicking on it<br />
							VL10B: fill in FI54 =&gt; go to Purchase Order =&gt; enter =&gt; click on background =&gt; F5 =&gt; shift F	<br /><br />
							use YSD_Pack =&gt; paste delivery-nr here =&gt; enter =&gt; F8 =&gt; go to tab TEXT =&gt; in header note 3 type SCRAP<br /> =&gt;
							go to PACK (shift F6) =&gt; Go to tab single entry : fill 1 in "HU Identification 2 . This is the amount of the package you want to use for shipping =&gt; At HU Identification 2 =&gt; 
							pack materials : fill in Nokia box barcode of the box =&gt; enter <br />
							=&gt; scan barcode of item 2X in field 2D barcode. =&gt;Go to tab Pack HUs : enter weight in Total Weight =&gt; save =&gt; Post Good Issue or Pre-PGI.<br /><br />							
							Use YSDVT70 to printout shipping and summery papers and address-label =&gt;  remove (shipmentnr en Fi28) click on delivery =&gt; F8 =&gt; select all (F5) =&gt; Shift F2.<br />
							One version of shipping-paper will be kept as archive and give the account-team.<br /><br />
							Stick the export-label on the enveloppe containing Address-label and shipping-papers =&gt; Stick SCRAP-label on the outer-box<br />
							After creation of AWB =&gt; go to header-note 3 of delivery and scan this AWB in above the word SCRAP =&gt; Use OTM to fill in DHL and printout AWB
						</p>
						<h2>OutBound IR</h2>
						<p>
							Power on the RFID-box-scanner =&gt; open IE and login RFID  (ceva_user, ceva123) =&gt; click op HWS printing, select R&R printer <br />
							=&gt; select the right repair vendor =&gt; scan serials in =&gt; check if the quantities of items is correct =&gt; close shipment.<br />
							Drive the pallet in the RFID-box =&gt; if RFID-scanner does not able to read serial, then you can fill the serial in manually till all serials are green<br />
							=&gt; check address of repair vendor and the items on the rfid-paper =&gt; shipment OK<br />
							Start VT01N  =&gt; FI28 =&gt; select at shipment type = Return trckg ship =&gt; enter =&gt; F6 at type of deliveries =&gt; click on import from text file (Shift +F11) <br />
							=&gt; browse naar C-drive =&gt; users=&gt; user =&gt; desktop =&gt; select most recent RFID-files =&gt; F8 =&gt; 
							F8 =&gt; pack (Shift + F9) =&gt; fill or scan the code of outerbox, packing material <br />
							=&gt; select all deliveries =&gt; select handling unit =&gt; click on pack =&gt; fill in weight =&gt; F3 =&gt; save <br />
							Start VT02N (change shipment) =&gt; enter =&gt; at Fwd Agen : 397003 =&gt; click on planning =&gt; click on shipment completion =&gt; save<br />
							For printing out shipment-papers =&gt; Start YSDVT70 =&gt; remove delivery & shipping point =&gt; click on “shipment”=&gt; F8 =&gt; F5 =&gt; shift +F2 to select the options to print and press Enter<br />
							Use OTM to create AWB<br />
							If you want to ship outside SAP, then create OTM from scratch. select always economic<br />
							start VT02N op =&gt; at external ID1 =&gt; scan AWB-nr =&gt; Go to texts =&gt; header note 3 =&gt; scan AWB =&gt; save
						</p>
						<h2>OutBound common</h2>
						<p>
							Start YSD_PACK =&gt; fill in outbound-delivery-nr =&gt; go to pack (this is amount of package you will use) 1 =&gt; at HU..fill in the code for outerbox<br />
							Single entry Scan material & serial in =&gt; Go to "Pack" and fill in weight or modify volume<br />
							after inbooking =&gt; save =&gt; pre-pgi <br />
							If needed rfid-labels printout and stick on the items<br />
							Use LT24 to confirm the items, relabel the items with RFID-labels<br />
							Start YSD_PACK =&gt; type in deliverynr =&gt; go to package =&gt; single entry etc… =&gt; scan material & sn =&gt; PGI <br />
							start YSDVT70 =&gt; remove shippingpoint<br />
							For printing orders from Italy =&gt; go to extra’s delivery output =&gt; header =&gt; select ZDN7 =&gt; further data =&gt; select immediately =&gt; go back =&gt; save =&gt; print =&gt;2 =&gt; F8 select second process (shift +F5)
						</p>
						<h2>RFID process via SAP Printing</h2>
						<p>
							Faulty stock shipment creation =&gt; SAP Packing =&gt; select vendor =&gt; fill in SAP delivery =&gt; scan SNs =&gt; close shipment after done =&gt; start RFI-script-room.
						</p>
						<h2>Packing delivery out of shipment</h2>
						<p>
							VT02N select on planning & shipment completion =&gt; go to pack=&gt; pack HUs =&gt; click on empty-icon to unpack =&gt; click on delete-icon to  delete package<br />
							=&gt; go to deliveries =&gt; delete transport =&gt; VL09
						</p>
						<h2>Sending IR-scrap to France DHL Gennevilliers</h2>
						<p>
							start YMB01 to receive goods with using of PO, create return delivery with VL01N, use YSD_PACK for packaging the delivery, Go to headernote 3 fill SCRAP =&gt; Hu2 type in 1 =&gt; scan in code of Outerbox =&gt; scan 2d-barocde in =&gt; enter =&gt; scan 2d-barocde in again =&gt; enter =&gt;
							Post Good Issue <br/>								
							Print out one paper of packinglist Start VL02N =&gt;  <br />
							Start VT01N op =&gt; FI28<br />
							select at shipment type = tracking shipment , forward agent = 397003, select “planning and shipment completion” =&gt; click on deliveries =&gt; only outboundh deliveries =&gt;  scan delivery one by one<br />
							F8 =&gt; pack (Shift + F9) =&gt; fill in packing material =&gt; select all deliveries =&gt; select handling unit =&gt; click on pack =&gt; fill in the weight =&gt; F3 =&gt; save <br />
							In OTM from Scratch label making. sending the items to next address: DHL Services Logistiques, 99-101 Avenue Louis Roche, 92230 Gennevilliers, France.
							Sending with OTM-scratch and email to Customer Service shipment-number and AWB-number
						</p>
						<h2>Scratch order release in OTM</h2>																
						<p>
						At Source Location ID fill in FI26 for Tilburg =&gt; At Destination Location ID click on search-icon =&gt; select the right name and attention =&gt; click on "Finished" =&gt; at Source ERP SCRATCH =&gt;
						at DN Reference fill in IR-SCRAP Xvak =&gt; at ICO Term fill in "DAP" =&gt; then fill in info of pallet/colli. You have to fill in weight, height, length, width manually =&gt; Save =&gt;
						at DGR select "N" =&gt; click on "submit" =&gt; copy the OTM-number. That will be start with the date of today =&gt; Go to Manage Deliveries Finder and paste the OTM-nr in =&gt; then process further as normal.=&gt;
	                    <p> <img src={OTMnr} alt="OTM Number" style={{ maxWidth: '100%', height: 'auto' }} /> </p>				
						In "Courier Specific Fields "Go to DHL Shipping Account and fill in 191983782 <br/>
	                    <p> <img src={OTMscratch01} alt="OTM specific fields" style={{ maxWidth: '100%', height: 'auto' }} /> </p>					
	                    <p> <img src={OTMscratch02} alt="OTM scratch specific fields" style={{ maxWidth: '100%', height: 'auto' }} /> </p>					
							Destination-ID of DHL genevillier is 3370001817							
						</p>
						<p>click on "Finished" =&gt; secure routes =&gt;  click on "manage results" =&gt; click on "documents" =&gt; click on glasses-icon =&gt; CTRL+P to printout AWB</p>
					</PanelBody>
						<footer style={{ marginTop: '2rem', padding: '1rem 0', borderTop: '1px solid #ddd' }}>
						  <p style={{ textAlign: 'center', fontSize: '0.9rem', color: '#666' }}>
						    &copy; 2025 by TQT Tong. All rights reserved.
						  </p>
						</footer>
								
				</Panel>
		
			</div>
		)
	}
}

export default RLC;
